<template>
  <div class="popularAccountsBox">
    <!-- For Advertiser -->
    <a
      href="#rates"
      class="pull-right view-all-link"
      v-show="!isBankNameLong"
    >View all {{bank.Name}} accounts &raquo;</a>
      
    <h2 class="mt-10">{{title}}</h2>
    <div class="anchor-tag four-a-color"><how-da-gets-paid></how-da-gets-paid> <span style="padding-left: 4px; padding-right: 4px; color: #aaa;">  | </span> <ad-disclosure-tooltip></ad-disclosure-tooltip></div>
    <table class="table table-condensed pa-table">
      <tbody>
        <tr class="popular-account-head">
          <th>Account Type</th>
          <th><apy-label></apy-label></th>
          <th>Account Name</th>
          <th>Min to Earn</th>
          <th>Max</th>
          <th></th>
        </tr>
        <popular-account v-for="ad in ads" v-bind:key="ad.id" v-bind:ad="ad"></popular-account>
      </tbody>
    </table>
    <a
      href="#rates"
      v-show="isBankNameLong"
      class="pull-right view-all-link-long-name"
    >View all {{bank.Name}} accounts &raquo;</a>
    <div class="clearfix"></div>
  </div>
</template>
<script lang="ts">
import Vue, { defineComponent } from "vue";
import popularAccount from "./popularAccount.vue";
import apiClient from "../../../services/apiClient";
import analytics from "../../../services/analytics";
import apyLabel from "../../../components/apyLabel.vue";
import howDaGetsPaid from '../../../components/how-da-get-paid.vue';
import adDisclosureTooltip from '../../../components/ad-disclosure-tooltip.vue';

export default defineComponent({
  name: "popularAccountsForAdvertiser",
  components: {
    popularAccount: popularAccount,
    apyLabel: apyLabel,
    howDaGetsPaid,
    adDisclosureTooltip
  },
  props: {
    ads: Array,
    bank: Object
  },
  computed: {
    isBankNameLong: function() {
      return (this.bank as any).Name.length > 17;
    },
    title: function(): string {
      const pluralSuffix = (this.ads as any).length > 1 ? "s" : "";

      //Amex doesn't like "Most Popular"
      if ((this.bank as any).Id === 791) {
        return (
          "Sponsored " +
          (this.bank as any).Name +
          " Account" +
          pluralSuffix
        );
      }
      return (
        "Most Popular " +
        (this.bank as any).Name +
        " Account" +
        pluralSuffix
      );
    }
  }
});
</script>
<style lang="scss" scoped>
.popularAccountsBox {
  .view-all-link {
    padding-top: 5px;
  }
  .view-all-link-long-name {
    text-decoration: none;
    margin-top: -10px;
    padding-bottom: 15px;
  }
  .pa-table {
    font-family: "Titillium Web";
    .popular-account-head th {
      color: #999;
      font-style: normal;
      background-color: #f2f2f2;
      border-bottom: 1px dotted #999;
      font-weight: normal;
      border-top: none;
    }
    th:first-child,
    th:nth-child(3) {
      padding-left: 10px;
      text-align: left;
    }
  }
}
.anchor-tag{
      color: #4699bb;
}
.mt-10{
  margin-top: 10px;
}
.four-a-color {
          color: #4a4a4a !important;
          margin-bottom: 15px;
        }
</style>
